import script from "./EditMetrics.vue?vue&type=script&setup=true&lang=js"
export * from "./EditMetrics.vue?vue&type=script&setup=true&lang=js"

import "./EditMetrics.vue?vue&type=style&index=0&id=66fc996d&lang=css"

const __exports__ = script;

export default __exports__